import { EmailDomains } from '../constants/Constants';

export function debug(message: string) {
  (window.location.hostname !== 'silencio.gso.amazon.dev') && console.log(message);
}

export function getTimeString(timestamp: number) {
    const date = new Date(timestamp);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}

export function validEmailAddresses(emailAddresses: string): boolean {
    debug(`ChangeStatus() validEmailAddresses() emailAddresses is ${emailAddresses}`);
    const regex: RegExp = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.][\s]*(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    const regex_result = regex.test(emailAddresses);
    debug(`ChangeStatus() validEmailAddresses() regex_result is ${regex_result}`);
    if (!regex_result) return false;
    const emailsList = emailAddresses.split(',');
    for (let email of emailsList) {
      debug(`ChangeStatus() validEmailAddresses() email is ${email}`);
      const domain = email.split('@')[1];
      debug(`ChangeStatus() validEmailAddresses() domain is ${domain}`);
      if (!EmailDomains.includes(domain)) return false;
    } 
    return regex_result;
  }